<ng-container *ngIf="worker">
  <ng-container *transloco="let t">


  <div class="row justify-content-start mt-3">
    <div class="col-12">

  <form [formGroup]="formGroup" cForm (ngSubmit)="submitForm()" class="info-form">

    <div class="row">
      <div class="col-12 col-md-6">

        <div class="form-group row mb-2" >
          <label class="col-6 col-form-label text-start text-sm-end"><svg cIcon name="cilAlarm"></svg> {{ t('Check In Frequency') }}</label>
          <div class="col-6">
            <ng-select
              [items]="check_in_times"
              bindLabel="name"
              bindValue="value"
              formControlName="check_in_freq"
              placeholder="{{ t('None') }}"
            >
            </ng-select>
            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('How often the user must check in to let the monitor know they are ok.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
          </div>
        </div>
        @if(worker.status && worker.status.working) {
          <p class="alert alert-info"><i class="fa-solid fa-triangle-exclamation text-info"></i> {{ t('The check in frequency cannot be changed while this worker has an active session in OK Alone.') }}</p>
        }

        <ng-container *ngIf="okService.hasFeature('checkin_reminders')">

        <hr />

        @if(okService.hasFeature('whatsapp')) {
        <div class="form-group row mb-2" >
          <label class="col-6 col-form-label text-start text-sm-end"><i class="fa-brands fa-whatsapp"></i> {{ t('WhatsApp') }}</label>
          <div class="col-6">
            <ng-select
              [items]="whatsapp_options"
              bindLabel="name"
              bindValue="value"
              formControlName="whatsapp"
            >
            </ng-select>
            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('Should the worker get SMS reminders via WhatsApp as well/instead.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
          </div>
        </div>

        <hr />
        }


        <div class="form-group row mb-2" >
          <label class="col-6 col-form-label text-start text-sm-end"><svg cIcon name="cilPhone"></svg> {{ t('Call Reminder (every mins)') }}</label>
          <div class="col-6">
            <ng-select
              [items]="alert_times"
              bindLabel="name"
              bindValue="value"
              formControlName="call_alert"
              placeholder="{{ t('None') }}"
              [readonly]="!okService.billing.plan.comms_active"
              (change)="hideCallReminders()"
            >
            </ng-select>
            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('Make a phone call to the worker after the check in is missed. Please select how many minutes after the missed check in you would like the call to be made.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
          </div>
        </div>

        <div class="form-group row mb-2" *ngIf="call_reminders">
          <label class="col-6 col-form-label text-start text-sm-end"><svg cIcon name="cilPhone"></svg> {{ t('Call Reminder Count') }}</label>
          <div class="col-6">
            <ng-select
              [items]="alert_repeat"
              bindLabel="name"
              bindValue="value"
              formControlName="call_alert_repeat"
              placeholder="{{ t('None') }}"
              [readonly]="!okService.billing.plan.comms_active"
              (change)="totalRepeats()"
            >
            </ng-select>
            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('How many times should the call reminder be sent out if they do not check in.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
          </div>
        </div>


        <hr />


        <div class="form-group row mb-2" >
          <label class="col-6 col-form-label text-start text-sm-end"><svg cIcon name="cilMobile"></svg> {{ t('SMS Reminder (every mins)') }}</label>
          <div class="col-6">
            <ng-select
              [items]="alert_times"
              bindLabel="name"
              bindValue="value"
              formControlName="sms_alert"
              placeholder="{{ t('None') }}"
              [readonly]="!okService.billing.plan.comms_active"
              (change)="hideSMSReminders()"
            >
            </ng-select>
            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('Send an SMS reminder to the cell phone after the check in is missed. Please select how many minutes after the missed check in you would like the reminder.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
          </div>
        </div>


        <div class="form-group row mb-2" *ngIf="sms_reminders">
          <label class="col-6 col-form-label text-start text-sm-end"><svg cIcon name="cilMobile"></svg> {{ t('SMS Reminder Count') }}</label>
          <div class="col-6">
            <ng-select
              [items]="alert_repeat"
              bindLabel="name"
              bindValue="value"
              formControlName="sms_alert_repeat"
              placeholder="{{ t('None') }}"
              [readonly]="!okService.billing.plan.comms_active"
              (change)="totalRepeats()"
            >
            </ng-select>
            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('How many times should the SMS reminder be sent out if they do not check in.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
          </div>
        </div>

        @if(okService.settings.arc_on) {
          <p class="alert alert-warning"><i class="fa-solid fa-triangle-exclamation text-danger"></i> {{ t('Worker reminders cannot be changed as this account is using our Safety Monitoring Center.') }}</p>
        }

      </ng-container>


        <ng-container *ngIf="okService.hasFeature('email_reminder')">

          <hr />

          <div class="form-group row mb-2" >
            <label class="col-6 col-form-label text-start text-sm-end"><svg cIcon name="cilEnvelopeClosed"></svg> {{ t('Email Reminder') }}</label>
            <div class="col-6">

              <ng-select
                [items]="alert_times"
                bindLabel="name"
                bindValue="value"
                formControlName="email_alert"
                placeholder="{{ t('None') }}"
                [readonly]="!okService.billing.plan.comms_active"
              >
              </ng-select>

              <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" [attr.data-bs-content]="t('Send an Email Reminder to the Worker when they miss a check in. An Email will only be sent one time, after the set number of minutes, when they first miss their check in.')">
                <i class="fa-solid fa-circle-info text-secondary" ></i>
              </button>
            </div>
          </div>

      </ng-container>

        <ng-container *ngIf="okService.hasFeature('email_reminder') || okService.hasFeature('checkin_reminders')">
          <div *ngIf="!okService.billing.plan.comms_active" class="alert alert-warning" role="alert">
            <i class="fa-solid fa-triangle-exclamation text-danger"></i> 
            @if(okService.billing.plan.account_type == "Pricing2024"){
              {{ t('To use check in reminders you must have the Automated Plan for your account. To set up an automated plan please go to your') }} 
            }@else{   
            {{ t('To use check in reminders you must have the Comms Plan for your account. To set up a comms plan please go to your') }} 
            }     
            <a routerLink="/account/account">{{ t('Account Settings') }}</a>.<br/>
            <i class="fa-solid fa-circle-info text-info"></i> {{ t('Learn more about check in reminders') }} <a href="https://okalone.zendesk.com/hc/en-gb/articles/35353033606289-Setting-Up-Worker-Reminders" target="_new">{{ t('here') }}</a>.
          </div>
          <div class="row m-2 alert alert-danger" *ngIf="tooManyRepeats">
            <div class="col">
              <span>{{ t('Please only choose a maximum of 4 combined SMS and Call Check-In Reminder Repeats') }}</span>
            </div>
          </div>
          <div *ngIf="okService.billing.plan.comms_active">
            <p><i class="fa-solid fa-circle-exclamation"></i>&nbsp;<b>{{ t('Call, SMS, and Email reminders are an automated service') }}</b></p>
          </div>
        </ng-container>


      </div>

      <div class="col col-12 col-lg-6">


        <a class="btn btn-primary float-end" href="https://okalone.zendesk.com/hc/en-gb/articles/35912389569553-Check-In-Frequency-for-Monitors" target="_new" role="button"><i class="fa-regular fa-circle-question"></i> {{ t('Help') }}</a>

        <p>{{ t('How will this worker use OK Alone:') }}</p>
        <div class="btn-group-vertical" role="group" aria-label="Vertical button group">
        <button type="button" class="btn " [ngClass]="worker.device!='Cell Phone' ? 'text-light btn-success' : 'btn-outline-secondary text-dark'" (click)="setDevice('Smartphone')">
          <c-row>
            <c-col class="col-12 col-md-4">
              <img src="assets/images/worker-smartphone.png" alt="Worker Smartphone" class="" height="100px"/>
            </c-col>
            <c-col class="col-12 col-md-8 text-left">
                <p>
                  <span class="fs-3">{{ t('Smartphone App') }}</span><br/>
                  {{ t('This worker has an iPhone or Android phone and they will use the OK Alone app to check in.') }}
                </p>
            </c-col>
          </c-row>
        </button>
        <button type="button" class="btn btn-outline-secondary  text-dark" [ngClass]="worker.device=='Cell Phone' ? 'text-light btn-success' : 'btn-outline-secondary text-dark'" (click)="setDevice('Cell Phone')">
          <c-row>
            <c-col class="col-12 col-md-4">
              <img src="assets/images/worker-mobile2.png" alt="Worker Older Phone" class="" height="100px"/>
            </c-col>
            <c-col class="col-12 col-md-8 text-left">
                <p>
                  <span class="fs-3">{{ t('Older Phone') }}</span><br/>
                  {{ t('This worker has an older phone and will check in by sending a text message or making a phone call to OK Alone.') }}
                </p>
            </c-col>
          </c-row>
        </button>
      </div>

      </div>
    </div>


    <c-row *ngIf="okService.hasMonitorWorkerAccess('workers','update')">
      <c-col xs="6" class="mt-3">
        <button cButton class="px-4 text-white btn-info" type="submit" [disabled]="tooManyRepeats">
          <i class="fa-solid fa-check"></i> {{ t('Update the Worker') }}
        </button>
      </c-col>
    </c-row>
  </form>

  </div></div>



    <div class="row justify-content-start mt-3">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              {{ t('Missed Check In Process') }}
              <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('If the worker does not check in on time the missed check in process starts')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
            </div>
            <div class="card-body">
              <p>{{ t('Here are the steps taken when a worker misses a check in, a high risk alert or has a worker down alert. A help alert has zero grace period.') }}</p>


              <div class="row mb-3" *ngIf="worker.checkin_process">

                <ng-container  *ngFor="let step of worker.checkin_process">

                    <div class="col-2 col-md-1  process-map " [ngClass]="{
                    'process-map1': step.type === 'start',
                    'process-email': step.type === 'email',
                    'process-sms': step.type === 'sms',
                    'process-call': step.type === 'call',
                    'process-map3': step.type === 'alert'}">
                      <br/><br/><br/><br/><br/>{{step.mins}} {{ t('mins') }}<br/><br/>&nbsp;
                    </div>

                </ng-container>
              </div>

            </div>
          </div>
        </div>
      </div>


    </ng-container>
</ng-container>
